var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12.5627 5.25C12.4712 6.52094 11.5284 7.5 10.5002 7.5C9.47211 7.5 8.52774 6.52125 8.43774 5.25C8.34399 3.92781 9.2618 3 10.5002 3C11.7387 3 12.6565 3.95187 12.5627 5.25Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10.4999 9.5C8.46331 9.5 6.50488 10.5116 6.01425 12.4816C5.94925 12.7422 6.11269 13 6.3805 13H14.6196C14.8874 13 15.0499 12.7422 14.9858 12.4816C14.4952 10.48 12.5368 9.5 10.4999 9.5Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.24981 5.81063C6.17669 6.82563 5.41481 7.625 4.59356 7.625C3.77231 7.625 3.00919 6.82594 2.93731 5.81063C2.86262 4.75469 3.60419 4 4.59356 4C5.58294 4 6.3245 4.77406 6.24981 5.81063Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.43732 9.5624C5.87325 9.30397 5.252 9.20459 4.59357 9.20459C2.96857 9.20459 1.40294 10.0124 1.01075 11.5858C0.959192 11.794 1.08982 11.9999 1.30357 11.9999H4.81232",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudience);
export default __webpack_public_path__ + "static/media/Audience.a12e95aacf13719bdbcdcc6ad3362238.svg";
export { ForwardRef as ReactComponent };